import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import { FIELDS } from './new';
import { UPDATE_ACCOUNT_GROUP } from './queries';

const EditAccountGroup = ({ accountGroup, setShowModal, refetch }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: accountGroup })
  });

  const [updateAccountGroup] = useMutation(UPDATE_ACCOUNT_GROUP, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    updateAccountGroup({ variables: prepareInput(input, FIELDS) });
  });

  return (
    <View>
      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Update Account Group" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default EditAccountGroup;
